<template>
  <Modal v-model="publishStoreModal" :title="$t('key1005667')" width="700" footer-hide :transfer="false" @on-visible-change="publishStoreChange">
    <Form ref="pageParams" :model="pageParams" :label-width="90" @submit.native.prevent>
      <Row type="flex" :gutter="gutterItem">
        <Col :xxl="threeItemCol" :xl="threeItemCol" :lg="threeItemCol" :md="threeItemCol">
          <Form-item :label="$t('key1005668')" prop="status">
            <Select v-model="pageParams.status">
              <Option v-for="item in statusList" :key="item.value" :value="item.value">{{ item.name }}</Option>
            </Select>
          </Form-item>
        </Col>
        <Col :xxl="threeItemCol" :xl="threeItemCol" :lg="threeItemCol" :md="threeItemCol">
          <Form-item :label="$t('key1005669')" prop="platformId">
            <Select v-model="pageParams.platformId">
              <Option v-for="(item,index) in platformList" :key="index" :value="item.platformId">{{ item.name }}</Option>
            </Select>
          </Form-item>
        </Col>
        <Col style="min-width: 170px;" push="1">
          <Button @click="reset" class="mr12">{{ $t('key1000109') }}</Button>
          <Button type="primary" @click="search">{{ $t('key1000361') }}</Button>
        </Col>
      </Row>
      <div class="table-box">
        <Table
          highlight-row
          border
          max-height="500"
          :loading="tableLoading"
          :columns="tableColumns"
          :data="tableData">
        </Table>
      </div>
    </Form>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from "@/components/mixin/common_mixin";

export default {
  name: "publishStoreModal",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      publishStoreModal: false,
      pageParams: {
        status: 'null',
        platformId: 'null'
      },
      statusList: [
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110'), value: 'null'},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005663'), value: 1},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005664'), value: 0},
      ],
      tableColumns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001793'),
          key: 'platformId',
          align: 'left',
          minWidth: 130
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005621'),
          key: 'account',
          align: 'left',
          minWidth: 120,
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005665'),
          key: 'itemNum',
          align: 'left',
          minWidth: 150,
          render(h, params) {
            let num = params.row.itemNum || 0;
            return h('span', num);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005666'),
          key: 'status',
          align: 'left',
          minWidth: 120,
          render(h, params) {
            let itemNum = params.row.itemNum || 0;
            let text = itemNum ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005663') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005664');
            return h('span', {class: itemNum > 0 ? 'distributorThemeColor' : ''}, text);
          }
        }
      ],
      tableData: [],
      platformList: [],
      originalData: [],
    };
  },
  created() {

  },
  methods: {
    // 初始化数据
    getPublishStoreData(data) {
      if (data && data.length > 0) {
        this.tableData = data;
        this.originalData = JSON.parse(JSON.stringify(data));
      }
      this.getProductPlatformData();
      this.publishStoreModal = true;
    },
    // 获取已经映射商品的平台数据
    getProductPlatformData() {
      let v = this;
      v.platformList = [];
      v.axios.get(api.get_ymsPlatform_api_queryProductPlatform).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas || [];
          if (data && data.length > 0) {
            data.unshift({
              platformId: 'null',
              name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110')
            });
            v.platformList = v.uniqueFunc(data, 'platformId');
          }
        }
      });
    },
    // 查询按钮
    search() {
      let v = this;
      v.tableData = [];
      v.tableLoading = true;
      let newData = JSON.parse(JSON.stringify(v.originalData));
      if (v.pageParams.status !== 'null') {
        newData = newData.filter((item) => {
          if (v.pageParams.status > 0) {
            return item.itemNum;
          } else {
            return !item.itemNum;
          }
        });
      }
      if (v.pageParams.platformId !== 'null') {
        newData = newData.filter((item) => {
          return item.platformId === v.pageParams.platformId;
        });
      }
      v.tableData = newData;
      v.tableLoading = false;
    },
    // 重置按钮
    reset() {
      let v = this;
      v.$refs['pageParams'].resetFields();
      v.search();
    },
    //监听弹窗
    publishStoreChange(value) {
      if (!value) {
        this.$nextTick(() => {
          this.reset();
        });
      }
    }
  }
};
</script>

<style lang="less" scoped>
.ivu-select-selected-value {
  font-size: 12px !important;
}
</style>